<template>
  <div>
    <v-card-title class='pa-0 pl-3 pt-1'>
      <div class="pa-0 px-1 font-weight-bold pt-2 text-h6 primary--text" v-if="!no_title">
        <v-icon color="primary">mdi-account-details</v-icon>
        Contratante
      </div>
    </v-card-title>
    <v-card-text v-if="client_data" class="px-0">
    <!-- <v-card-text v-if="event_info.client"> -->
      <div class="ml-7">
        <div class="pa-0 px-1 font-weight-bold pt-2">Nome do cliente:</div>
        <div class="pa-0 px-3">{{client_data.client_name}}</div>   
        <div class="pa-0 px-1 font-weight-bold pt-2">{{client_data.client_is == 'cpf' ? 'CPF' : 'CNPJ'}}</div>
        <div class="pa-0 px-3">{{client_data.document}}</div>   
        <div class="pa-0 px-1 font-weight-bold pt-2">Telefone:</div>
        <div class="pa-0 px-3">{{client_data.phone}}</div> 
        <div class="pa-0 px-1 font-weight-bold pt-2">E-mail:</div>
        <div class="pa-0 px-3">{{client_data.email}}</div> 
        <div class="pa-0 px-1 font-weight-bold pt-2">Endereço completo:</div>
        <div class="pa-0 px-3">{{client_data.client_address.full_address}}</div>
        <div class="pa-0 px-1 font-weight-bold pt-2" v-if="event_info.comment">Comentário: </div>
        <div class="pa-0 px-3" v-if="event_info.comment">{{event_info.comment}}</div>
        <div v-if="client_data.client_is == 'cnpj'">
          <v-divider></v-divider>
          <div class="pa-0 px-1 font-weight-bold pt-2">Nome do representante:</div>
          <div class="pa-0 px-3">{{client_data.corporate_person_name}}</div>
          <div class="pa-0 px-1 font-weight-bold pt-2">Documento: </div>
          <div class="pa-0 px-3">{{client_data.corporate_person_document}}</div>
        </div>      
      </div>
    </v-card-text>
  </div>
</template>
<script>
  export default {
    name: 'SummaryContractor',
    props: {
      event_info: {
        type: Object
      },
      no_title:{
        type: Boolean,
        default: false,
      }
    },
    computed: {
      client_data() {
        let data = null
        if (this.event_info.json_attributes || this.event_info.client){
          data = this.event_info.json_attributes || this.event_info
          data = data.client
          data.client_name = this.event_info.client_name
        }
        return data
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>